import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { NotFoundPage } from 'views/pages/errors/NotFoundPage';
import { LoginPage } from 'views/pages/LoginPage';
import { ConfigurationProfilePage } from 'views/pages/ConfigurationProfilePage';
import { AppsPage } from 'views/pages/AppsPage';
import { SAMLPage } from 'views/pages/SAMLPage';
import { SAMLLoginPage } from 'views/pages/SAMLLoginPage';
import { SignUpPage } from 'views/pages/SignUpPage';
import { WebclipPage } from 'views/pages/WebclipPage';
import { RequiredIphoneUidRoute } from 'views/Router/RequiredIphoneUidRoute';
import { CheckSessionRouter } from 'views/Router/CheckSessionRouter';
import { AppDetailPage } from 'views/pages/AppDetailPage';
import { DistributionDetailPage } from 'views/pages/DistributionDetailPage';
import { AppRoute } from 'views/Router/AppRoute';
import { CommentsPage } from 'views/pages/CommentsPage';
import { NotificationSettingPage } from 'views/pages/NotificationSettingPage';
import { RequiredIosSafari } from 'views/Router/RequiredIosSafari';
import { EmailActivationPage } from 'views/pages/EmailActivationPage';
import { LoginFromOAuthPage } from 'views/pages/LoginFromOAuthPage';
import { SDKDeviceVerificationPage } from 'views/pages/SDKDeviceVerificationPage';
import { RequiredAuthentication } from 'views/Router/RequiredAuthentication';
import { HandleAsyncError } from 'views/Router/HandleAsyncError';
import { ROUTER_PATH } from 'views/constants';
import { InvitationPage } from 'views/pages/InvitationPage';
import { MigrationPage } from 'views/pages/MigrationPage';
import { SetLocale } from 'views/Router/SetLocale';
import { SetPullToRefresh } from 'views/Router/SetPullToRefresh';
import { AppSearchPage } from 'views/pages/AppSearchPage';

export const Router: React.FC = () => {
  return (
    <HandleAsyncError>
      <CheckSessionRouter>
        <SetLocale>
          <SetPullToRefresh>
            <Switch>
              <AppRoute path={ROUTER_PATH.home} exact>
                <Redirect to={ROUTER_PATH.login} />
              </AppRoute>
              <AppRoute path={ROUTER_PATH.oauth} exact>
                <RequiredIosSafari>
                  <LoginFromOAuthPage />
                </RequiredIosSafari>
              </AppRoute>
              <AppRoute path={ROUTER_PATH.login} exact>
                <RequiredIosSafari>
                  <LoginPage />
                </RequiredIosSafari>
              </AppRoute>
              <AppRoute path={ROUTER_PATH.oauthSignUp} exact>
                <RequiredIosSafari>
                  <SignUpPage />
                </RequiredIosSafari>
              </AppRoute>
              <AppRoute path={ROUTER_PATH.signUp} exact>
                <RequiredIosSafari>
                  <SignUpPage />
                </RequiredIosSafari>
              </AppRoute>
              <AppRoute path={ROUTER_PATH.saml} exact>
                <RequiredIosSafari>
                  <SAMLPage />
                </RequiredIosSafari>
              </AppRoute>
              <AppRoute path={ROUTER_PATH.samlLogin} exact>
                <RequiredIosSafari>
                  <SAMLLoginPage />
                </RequiredIosSafari>
              </AppRoute>
              <AppRoute path={ROUTER_PATH.configurationProfile} exact>
                <RequiredIosSafari>
                  <ConfigurationProfilePage />
                </RequiredIosSafari>
              </AppRoute>
              <AppRoute path={ROUTER_PATH.webclip}>
                <RequiredIosSafari>
                  <WebclipPage />
                </RequiredIosSafari>
              </AppRoute>
              <AppRoute path={ROUTER_PATH.migration}>
                <RequiredIosSafari>
                  <MigrationPage />
                </RequiredIosSafari>
              </AppRoute>
              <RequiredIphoneUidRoute path={ROUTER_PATH.apps}>
                <RequiredIosSafari>
                  <AppsPage />
                </RequiredIosSafari>
              </RequiredIphoneUidRoute>
              <RequiredIphoneUidRoute path={ROUTER_PATH.userAppSearch} exact>
                <RequiredIosSafari>
                  <RequiredAuthentication>
                    <AppSearchPage />
                  </RequiredAuthentication>
                </RequiredIosSafari>
              </RequiredIphoneUidRoute>
              <RequiredIphoneUidRoute path={ROUTER_PATH.groupAppSearch} exact>
                <RequiredIosSafari>
                  <RequiredAuthentication>
                    <AppSearchPage />
                  </RequiredAuthentication>
                </RequiredIosSafari>
              </RequiredIphoneUidRoute>
              <RequiredIphoneUidRoute path={ROUTER_PATH.notificationSetting}>
                <RequiredIosSafari>
                  <NotificationSettingPage />
                </RequiredIosSafari>
              </RequiredIphoneUidRoute>
              <AppRoute path={ROUTER_PATH.emailActivations}>
                <EmailActivationPage />
              </AppRoute>
              <AppRoute path={ROUTER_PATH.invitationDetail}>
                <RequiredIosSafari>
                  <InvitationPage />
                </RequiredIosSafari>
              </AppRoute>
              <RequiredIphoneUidRoute path={ROUTER_PATH.userApp} exact>
                <RequiredIosSafari>
                  <RequiredAuthentication>
                    <AppDetailPage />
                  </RequiredAuthentication>
                </RequiredIosSafari>
              </RequiredIphoneUidRoute>
              <RequiredIphoneUidRoute path={ROUTER_PATH.groupApp} exact>
                <RequiredIosSafari>
                  <RequiredAuthentication>
                    <AppDetailPage />
                  </RequiredAuthentication>
                </RequiredIosSafari>
              </RequiredIphoneUidRoute>
              <RequiredIphoneUidRoute path={ROUTER_PATH.distribution} exact>
                <RequiredIosSafari>
                  <DistributionDetailPage />
                </RequiredIosSafari>
              </RequiredIphoneUidRoute>
              <RequiredIphoneUidRoute
                path={ROUTER_PATH.distributionComments}
                exact
              >
                <RequiredIosSafari>
                  <CommentsPage />
                </RequiredIosSafari>
              </RequiredIphoneUidRoute>
              <AppRoute path={ROUTER_PATH.sdkDeviceVerification}>
                <RequiredIosSafari>
                  <SDKDeviceVerificationPage />
                </RequiredIosSafari>
              </AppRoute>
              <AppRoute>
                <RequiredIosSafari>
                  <NotFoundPage />
                </RequiredIosSafari>
              </AppRoute>
            </Switch>
          </SetPullToRefresh>
        </SetLocale>
      </CheckSessionRouter>
    </HandleAsyncError>
  );
};
